import { Button } from '@mui/material';
import { ErmsCardEnum, IErmsSelectCard } from 'interfaces/erms';
import { FC } from 'react';

interface ErmsSelectCardProps {
  item: IErmsSelectCard;
  selectedCard: ErmsCardEnum;
  setSelectedCard: (arg: ErmsCardEnum) => void;
}

const ErmsSelectCard: FC<ErmsSelectCardProps> = ({ item, selectedCard, setSelectedCard }) => {
  const handleClickCard = (value: ErmsCardEnum) => {
    setSelectedCard(value);
  };

  return (
    <Button
      key={item.key}
      sx={{
        height: '88px',
        width: '88px',
        borderRadius: '8px',
        backgroundColor: 'grey',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        border: (theme) =>
          `1px solid ${item.value === selectedCard ? theme.palette.primary.main : theme.palette.color.grey8}`,
        color: (theme) => (item.value === selectedCard ? theme.palette.primary.main : theme.palette.color.grey8),
      }}
      onClick={() => handleClickCard(item.value)}>
      {item.avatar}
      {item.label}
    </Button>
  );
};

export default ErmsSelectCard;
